export const replaceUmlauts = (text) => {
  return text
    .replace(/\u00dc/g, 'UE')
    .replace(/\u00fc/g, 'ue')
    .replace(/\u00c4/g, 'AE')
    .replace(/\u00e4/g, 'ae')
    .replace(/\u00d6/g, 'OE')
    .replace(/\u00f6/g, 'oe')
    .replace(/\u00df/g, 'ss');
};
